import { GetUserPermissions } from "@/shared/domain/usecases/permissions/getUserPermissions";
import { makeSSOApiDatasource } from "../../datasources/sso-api-datasource-factory";
export var makeGetUserPermissions = function () {
    return new GetUserPermissions(makeSSOApiDatasource());
};
